module.exports = __webpack_public_path__ + "img/00030.0006c2e3.webp";